import { formatFieldDate } from '@inference.engine/taxonomy/web';

/**
 * Renders a date against a FIELD's mask (tokens: YYYY, YY, MMM, MM, DD).
 *
 * Re-exported rather than implemented here: the generator renders the same
 * tokens, and the two hand-written copies of that substitution chain were free
 * to drift — which is how a cleared mask came to mean "no characters" to the
 * generator and "the full date" to the preview standing next to it.
 *
 * Blank falls back to the full mask, which is correct HERE and only here: this
 * is what the date picker writes, and a picker always produces a date. A
 * tracking-code PART is the opposite case and must use `formatPartDate`.
 */
export const formatDateMask = formatFieldDate;
